import React from "react";
import {connect} from "react-redux";
import {find} from 'lodash'
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Table from "components/Table/Table.jsx";
import Checkbox from "components/Checkbox/Checkbox";
import Add from "@material-ui/icons/Add";
import Create from "@material-ui/icons/Create";
import Close from "@material-ui/icons/Close";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import CheckboxCore from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import {
  ibSave,
  //ibsFetch,
  ibFetch
} from 'actions/ibs'
import {
  plaformsFetch,
  plaformFilter
} from 'actions/platforms'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'
import {
  danger,
} from 'actions/notification'

class IbTradingAccounts extends React.Component {
	state = {
		selected: -1,
		showForm: false,
		form:{
			number: '',
			currencyId: 0,
			platformId: 0,
			defaultTradingAccount: true
		},
		ib:{
			tradingAccounts: []
		}
  }
  componentDidMount(){
		this.props.plaformFilter({size: 100})
		this.props.currencyFilter({size: 10000})
		this.props.platformsFetch();
		this.props.currenciesFetch();


	  if(this.props.match.params.id) {
		  this.props.saveWizardData(this.props.stepDataObject.data)
		  this.setState({
			  ...this.state,
			  ib: {
				  tradingAccounts: this.props.stepDataObject.data.tradingAccounts
			  }
		  })
	  }

  }
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: <small>(optional)</small>)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}

	addNew(){
		this.setState({
			...this.state,
			showForm: true,
			form:{
				number: '',
				currencyId: 0,
				platformId: 0,
				defaultTradingAccount: true,
			}
		})
		
	}

	saveTableItem(e){
		e.preventDefault()
		const state = this.state
		let ib = this.state.ib
		const newItem = {
			number: this.state.form.number,
			currencyId: this.state.form.currencyId,
			platformId:  this.state.form.platformId,
			defaultTradingAccount: this.state.form.defaultTradingAccount
		}
		if(this.state.form.tradingAccountId){
			newItem.tradingAccountId = this.state.form.tradingAccountId
			ib.tradingAccounts = ib.tradingAccounts.filter((x) => x.tradingAccountId !== newItem.tradingAccountId)
		}
		if(newItem.defaultTradingAccount){
			//remove default from other nodes
			ib.tradingAccounts = ib.tradingAccounts.map((item) => {
				item.defaultTradingAccount = false
				return item
			})
		}
		
		ib.tradingAccounts.push(newItem)
		let data = {...this.props.wizardData, ...ib}
    this.props.save(data)
      .then(e => {
				this.props.fetch(e.ibId)
					.then((res) => {
						this.props.saveWizardData(e)
						this.setState({
							...state,
							ib:{
								tradingAccounts: res.tradingAccounts
							},
							showForm: false
						})

					})
        //this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
	}
	closeForm(){
		this.setState({
			...this.state,
			showForm: false
		})
	}
	setCheckboxValue(key){
		const {form} = this.state
		let keyItemValue = form[key]

		this.setState({
			...this.state,
			form: {
				...form,
				[key]: !keyItemValue
			}
		})
	}
	renderCheckbox(options){
		const {classes} = this.props
		const value = this.state.form[options.key]
		return(
			<div
				key={options.key}
				className={
					classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}
			>
				<FormControlLabel
					control={
						<CheckboxCore
							tabIndex={-1}
							onClick={() => this.setCheckboxValue(options.key)}
							checked={value}
							checkedIcon={
								<Check className={classes.checkedIcon} />
							}
							icon={<Check className={classes.uncheckedIcon} />}
							classes={{
								checked: classes.checked
							}}
						/>
					}
					classes={{
						label: classes.label
					}}
					label={options.label}
				/>
			</div>
		)
	}
	renderAddItemForm(){
		const {classes} = this.props
		return(
			<form onSubmit={(e) => this.saveTableItem(e)}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={11} md={11}>
						
						{this.getInput({
							key:'number',
							name:'Number',
							icon:'',
							type:'text',
							required:true
						})}
					
						<FormControl
							fullWidth
							className={classes.selectFormControl}
							style={{marginTop:'10px', marginBottom: '17px'}}
						>

							<InputLabel
								htmlFor="currencyId"
								className={classes.selectLabel}
							>
								Currency*
							</InputLabel>

							<Select
								required={true}
								native
								value={this.state.form.currencyId || '' }
								MenuProps={{ className: classes.selectMenu }}
								classes={{ select: classes.select }}            
								inputProps={{
									onChange: event => this.change(event, "currencyId"),
									id: "currencyId"
								}}
							>
								<option value="" disabled></option>
								{Object.values(this.props.currencies).map(item => 
									<option key={item.currencyId} value={item.currencyId}>{item.name}</option>
								)}
							</Select>  
						</FormControl>
						
						
						<FormControl
							fullWidth
							className={classes.selectFormControl}
							style={{marginTop:'10px', marginBottom: '17px'}}
						>

							<InputLabel
								htmlFor="platformId"
								className={classes.selectLabel}
							>
								Platform*
							</InputLabel>

							<Select
								required={true}
								native
								value={this.state.form.platformId || '' }
								MenuProps={{ className: classes.selectMenu }}
								classes={{ select: classes.select }}            
								inputProps={{
									onChange: event => this.change(event, "platformId"),
									id: "platformId"
								}}
							>
								<option value="" disabled></option>
								{Object.values(this.props.platforms).map(item => 
									<option key={item.platformId} value={item.platformId}>{item.name}</option>
								)}
							</Select>  
						</FormControl>

					</GridItem>
					<GridItem xs={12} sm={11} md={11}>
						<div style={{float: 'left'}}>
							{this.renderCheckbox({key: 'defaultTradingAccount', label: 'Make this default'})}
						</div>
						<div style={{float: 'right'}}>
							<Button
								color="danger"
								type="button"
								onClick={(e) => this.closeForm()}
							>
								Cancel
							</Button>
							<Button
								color="success"
								type="submit"
							>
								{this.state.form.tradingAccountId ? 'Edit' : 'Add'}
							</Button>
						</div>
					</GridItem>
				</GridContainer>
			</form>
		)

	}
	select(id){
		let selected = this.state.selected === id ? -1 : id
		this.setState({
			...this.state,
			selected: selected
		})
	}
	editFormItem(e){
		const {ib:{tradingAccounts}, selected} = this.state
		const itemToEdit = tradingAccounts.find((x) => x.tradingAccountId === selected)
		this.setState({
			...this.state,
			form: itemToEdit,
			showForm: true
		})
	}
	deleteItem(id){
		let ib = this.state.ib
		ib.tradingAccounts = ib.tradingAccounts.filter((x) => x.tradingAccountId !== id)
		let data = {...this.props.wizardData, ...ib}
    this.props.save(data)
      .then(e => {
				this.props.fetch(e.ibId)
					.then((res) => {
						this.setState({
							...state,
							ib:{
								tradingAccounts: res.tradingAccounts
							},
							showForm: false
						})

					})
        //this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})

	}
  render() {
		//const {classes} = this.props
		let {showForm, ib} = this.state

		return (
			<GridContainer justify="center">

				{!showForm && (
					<GridContainer justify="center">
					
						<GridItem xs={11} sm={11}>
							<div style={{float: 'right'}}>
								<span
									onClick={() => this.addNew()}
								>
									<Add
										style={{
											boxShadow: '0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)',
											backgroundColor: '#00acc1',
											color: 'white',
											border: 'transparent',
											height: '30px',
											width: '30px',
											borderRadius: '50%',
											cursor: 'pointer'
										}}
									/>
								</span>
							</div>
							
						</GridItem>
						<GridItem xs={11} sm={11} md={11}>
						
							<div style={{border:'1px solid #AAAAAA', marginTop: '20px'}}>
								<Table
									tableHeaderColor="primary"
									striped
									responsiveY
									tableHead={{
										checkbox: '',
										bankAccountId: '#',
										number: 'Number',
										currencyId:"Currency", 
										platformId:"Platform",
										actions: ''
									}}
									tableData={ib.tradingAccounts.sort((a, b) => a.tradingAccountId - b.tradingAccountId).map((e,i) => [
										<Checkbox props={{
											onClick:()=>this.select(e.tradingAccountId),
                      checked:this.state.selected===e.tradingAccountId
										}} />,
										e.tradingAccountId,
										e.number,
										find(this.props.currencies, (c) => c.currencyId === e.currencyId).name, 
										find(this.props.platforms, (c) => c.platformId === e.platformId).name,
										<div>
											
											<span
												style={{
													cursor: 'pointer',
													visibility: this.state.selected === e.tradingAccountId ? 'visible' : 'collapse'
												}}
												onClick={(e) => this.editFormItem(e)}
											>
												<Create />
											</span>

											<span
												style={{
													color: '#f44336',
													cursor: 'pointer',
													visibility: this.state.selected === e.tradingAccountId ? 'visible' : 'collapse'
												}}
												onClick={(x) => this.deleteItem(e.tradingAccountId)}
											>
												<Close />
											</span>
											
											
										</div>
									])}
								/>
							</div>
						</GridItem>
					</GridContainer>
				)}
				

				{showForm && (
					this.renderAddItemForm()
				)}

				<GridItem sm={11}>
					<div style={{float: 'left'}}>
						<Button
							// color="success"
							type="button"
							onClick={(e) => this.props.goToPreviousStep(ib)}
							style={{position:'absolute', bottom:'10px', left:'40px'}}
						>
							Previous
						</Button>
					</div>
					<div style={{float: 'right'}}>
						<Button
							color="success"
							type="button"
							onClick={(e) => this.props.goToNextStep(ib)}
							style={{position:'absolute', bottom:'10px', right:'40px'}}
						>
							Next
						</Button>
					</div>
				</GridItem>
			</GridContainer>
		)
  }
}
const state=(state)=>({
	ibs: state.ibs,
	currencies: state.currencies.list,
	platforms: state.platforms.list
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  save:(data)=>dispatch(ibSave(data)),
	danger:(text,sec)=>dispatch(danger(text,sec)),
	currenciesFetch: () => dispatch(currenciesFetch()),
	currencyFilter: (filter) => dispatch(currencyFilter(filter)),
  platformsFetch: () => dispatch(plaformsFetch()),
  plaformFilter: (filter) => dispatch(plaformFilter(filter))
})
export default withStyles({...styles, ...regularFormsStyle})(connect(state,dispatch)(IbTradingAccounts))



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/IbTradingAccounts.jsx